// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapButton, BootstrapIcon } from '../../../../dsl/front'

/**
 * @author Sebastian Dziechciarz
 */
@Component({
  name: 'ShareButton',
  components: {
    BootstrapButton,
    BootstrapIcon
  },

  template: `
    <button class="share-button" @click="onClick">
      <BootstrapIcon :name="actionIcon" size="small" class="share-button__icon"
                     :class="{'text-success':(actionIcon==='checkmark')}" :alt="label" />
      {{ count }}
    </button>
  `
})
export class ShareButton extends Vue {
  /**
   * Function that will be called when the User clicks the action `<button>`.
   */
  @Prop({
    type: Function,
    required: true
  })
  private readonly callback!: () => boolean | undefined

  private actionIcon: string = ''

  created () {
    this.actionIcon = this.icon
  }

  /**
   * The name (identifier) of the action's icon.
   */
  @Prop({
    type: String,
    required: false,
    default: ''
  })
  public readonly icon!: string

  /**
   * The name (identifier) of the action's icon.
   */
  @Prop({
    type: String,
    required: false,
    default: ''
  })
  public readonly clickedIcon?: string | null

  /**
   * The `<button>`s label.
   */
  @Prop({
    type: String,
    required: true
  })
  public readonly label!: string

  @Prop({
    type: Number,
    required: false
  })
  public readonly count?: number

  /**
   * Handles `@click` event on the `<button>`.
   */
  public onClick (): void {
    this.callback()
    if (this.clickedIcon) {
      this.actionIcon = this.clickedIcon
      setTimeout(() => {
        this.actionIcon = this.icon
      }, 2000)
    }
  }
}

export default ShareButton
